export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"facebook-domain-verification","content":"zbygx01np4qvoovuwtdcp3isqfqt3q"}],"link":[],"style":[],"script":[{"type":"application/ld+json","children":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"Bali Bikes Island\",\"alternateName\":\"BBI\",\"description\":\"Rent a scooter or motorbike in Bali for your day-to-day adventures. Bali Bikes Island offers easy, daily rentals with free delivery and well-maintained bikes.\",\"url\":\"https://balibikesisland.com\",\"logo\":\"https://balibikesisland.com/assets/logo-bali-bikes-main.png\",\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"Jl. Danau Poso No.61, Sanur Kauh, Denpasar Selatan, Kota Denpasar, Bali\",\"addressLocality\":\"Bali\",\"addressRegion\":\"ID-BA\",\"postalCode\":\"80118\",\"addressCountry\":\"ID\"},\"email\":\"info@balibikesisland.com\",\"telephone\":\"+62811194881\",\"contactPoint\":{\"@type\":\"ContactPoint\",\"telephone\":\"+62811194881\",\"email\":\"info@balibikesisland.com\"}}"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = true

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false